import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { colors } from 'styles/theme';

const buttonCss = css`
  padding: 14px;
  outline: none;
  background-color: transparent;
  border: none;
`;

const lineCss = css`
  width: 18px;
  height: 2px;
  margin: 4px 0;
  border-radius: 1px;
  background-color: ${colors.textColor};
`;

/**
 * @param {object} props
 */
function Hamburger({ onClick, className }) {
  return (
    <button onClick={onClick} css={buttonCss} className={className}>
      <div css={lineCss} />
      <div css={lineCss} />
      <div css={lineCss} />
    </button>
  );
}

Hamburger.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default Hamburger;
